<template>
    <footer class="footer">
        <div class="container">
            <div class="row">
                <!-- footer list -->
                <div class="col-12 col-md-3">
                    <h6 class="footer__title">Baixe nosso aplicativo</h6>
                    <ul class="footer__app">
                        <li><a href="#"><img src="static/img/Download_on_the_App_Store_Badge.svg" alt=""></a></li>
                        <li><a href="#"><img src="static/img/google-play-badge.png" alt=""></a></li>
                    </ul>
                </div>
                <!-- end footer list -->

                <!-- footer list -->
                <div class="col-6 col-sm-4 col-md-3">
                    <h6 class="footer__title">Sobre nós</h6>
                    <ul class="footer__list">
                        <li><a href="#">Sobre</a></li>
                        <li><a href="#">Preços</a></li>
                        <li><a href="#">Contato</a></li>
                    </ul>
                </div>
                <!-- end footer list -->

                <!-- footer list -->
                <div class="col-6 col-sm-4 col-md-3">
                    <h6 class="footer__title">Outros</h6>
                    <ul class="footer__list">
                        <li><a href="#">Termos de uso</a></li>
                        <li><a href="#">Politica de privacidade</a></li>
                        <li><a href="#">Suporte</a></li>
                    </ul>
                </div>
                <!-- end footer list -->

                <!-- footer list -->
                <div class="col-12 col-sm-4 col-md-3">
                    <h6 class="footer__title">Contato</h6>
                    <ul class="footer__list">
                        <li><a href="tel:+18002345678">+55 21 98169-2318</a></li>
                        <li><a href="mailto:support@moviego.com">danielazevedo2k2@gmail.com</a></li>
                    </ul>
                    <ul class="footer__social">
                        <li class="facebook"><a href="https://www.facebook.com/dazevedoguimaraes#"><i class="icon ion-logo-facebook"></i></a></li>
                        <li class="instagram"><a href="https://www.instagram.com/danielaze2k12/"><i class="icon ion-logo-instagram"></i></a></li>
                        <li class="twitter"><a href="https://twitter.com/danganf"><i class="icon ion-logo-twitter"></i></a></li>
                    </ul>
                </div>
                <!-- end footer list -->

                <!-- footer copyright -->
                <div class="col-12">
                    <div class="footer__copyright">
                        <small><a target="_blank" href="https://www.templateshub.net">VUEFLIX</a></small>

                        <ul>
                            <li><a href="#">Termos de uso</a></li>
                            <li><a href="#">Politica de privacidade</a></li>
                        </ul>
                    </div>
                </div>
                <!-- end footer copyright -->
            </div>
        </div>
    </footer>
</template>

<script>

export default {
  components: {},
  data: () => {
    return {

    }
  },
  methods: {

  },

  mounted () {
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Footer.vue